/// REDUX ///
import { useAppDispatch } from "api/hooks/apiHook";
import { useAppSelector } from "api/hooks/apiHook";
/// REACT ///
import { Fragment } from "react";
import { useEffect } from "react";
import { useState } from "react";
/// TYPES ///
import { IShopArea } from "api/types/shop_quote/area";
import { IShopColor } from "api/types/shop_material";
import { IShopMaterial } from "api/types/shop_material";
/// ACTIONS ///
import { updateShopArea } from "api/actions/shop_quote";
import { updateLocalShopArea } from "api/actions/shop_quote";
import { markShopQuoteChanged } from "api/actions/shop_quote";
/// COMPONENTS ///
import MainColor from "components/quote/color_options/area/row/color";
import ShopCreateColor from "../../dialog/color/create";
import ShopCreateMaterial from "../../dialog/material/create";
import ShopUpdateMaterial from "../../dialog/material/update";
import ShopUpdateColor from "../../dialog/color/update";
/// LODASH ///
import { filter } from "lodash";
/// VALUES ///
import { QUARTZ } from "values/material";

interface Props {
  area: IShopArea,
  description: string,
}

export default function ShopMainColorItem({ area, description }: Props) {
  const dispatch = useAppDispatch();
  const { colors } = useAppSelector((state) => state.shop_material);
  const { materials } = useAppSelector((state) => state.shop_material);
  const [filt_mats, setFiltMats] = useState<IShopMaterial[]>([]);
  const [filt_colors, setFiltColors] = useState<IShopColor[]>([]);
  const [current_color, setCurrentColor] = useState<IShopColor>({});
  const [current_material, setCurrentMaterial] = useState<IShopMaterial>({});
  const [selected_type, setSelectedType] = useState<string>(area?.material_type ?? QUARTZ);
  const [selected_material, setSelectedMaterial] = useState<number>(0);
  const [selected_color, setSelectedColor] = useState<number>(0);
  const [create_material_open, setCreateMaterialOpen] = useState<boolean>(false);
  const [update_material_open, setUpdateMaterialOpen] = useState<boolean>(false);
  const [create_color_open, setCreateColorOpen] = useState<boolean>(false);
  const [edit_color_open, setEditColorOpen] = useState<boolean>(false);

  useEffect(() => {
    setSelectedType(area?.material_type);
  }, [area?.material_type]);

  useEffect(() => {
    for (let i = 0; i < filt_mats.length; i++) {
      if (filt_mats[i].id === area?.material) {
        setSelectedMaterial(filt_mats[i].id);
        setCurrentMaterial(filt_mats[i]);
      }
    }
  }, [filt_mats, area?.material]);

  useEffect(() => {
    for (let i = 0; i < filt_colors.length; i++) {
      if (filt_colors[i].id === area?.color) {
        setSelectedColor(filt_colors[i].id);
        setCurrentColor(filt_colors[i]);
      }
    }
  }, [filt_colors, area?.color]);

  useEffect(() => {
    setFiltMats(filter(materials, { "material_type": selected_type }));
  }, [setFiltMats, materials, selected_type]);

  useEffect(() => {
    setFiltColors(filter(colors, { "material": selected_material }));
  }, [colors, selected_material, setFiltColors]);

  const handleCurrentMaterial = (material: IShopMaterial) => {
    dispatch(updateLocalShopArea({ ...area, material: material.id }));
    setSelectedType(material.material_type);
    setSelectedMaterial(material.id);
    setCurrentMaterial(material);
  }

  const handleCurrentColor = (color: IShopColor) => {
    dispatch(updateLocalShopArea({ ...area, color: color.id }));
    setSelectedColor(color.id);
    setCurrentColor(color);
    saveColor(
      color.id,
      color.material,
      current_material.material_type,
      current_material.name,
      color.name,
      color.length,
      color.width
    );
  }

  const selectMaterial = (material: IShopMaterial) => {
    setSelectedMaterial(material.id);
    setCurrentMaterial(material);
  }

  const selectColor = (color: IShopColor) => {
    setSelectedColor(color.id);
    setCurrentColor(color);
  }

  const saveColor = (
    color_id: number,
    material_id: number,
    material_type: string,
    material_name: string,
    color_name: string,
    color_length: number,
    color_width: number
  ) => {
    dispatch(updateShopArea({
      ...area,
      color: color_id,
      material: material_id,
      material_type: material_type,
      material_name: `${material_name} ${color_name}`,
      material_length: color_length,
      material_width: color_width
    },
      area?.id,
      true
    ));
    dispatch(markShopQuoteChanged());

  }

  return (
    <Fragment>
      <MainColor
        description={description}
        colors={filt_colors}
        materials={filt_mats}
        saveColor={saveColor}
        selected_type={selected_type}
        setSelectedType={setSelectedType}
        selected_material={selected_material}
        setSelectedMaterial={selectMaterial}
        selected_color={selected_color}
        setSelectedColor={selectColor}
        setCreateColorOpen={setCreateColorOpen}
        setEditColorOpen={setEditColorOpen}
        setCreateMaterialOpen={setCreateMaterialOpen}
        setEditMaterialOpen={setUpdateMaterialOpen}
        deleteColorOption={() => void 0}
        showNaturalStone
        hideDelete />
      <ShopCreateMaterial
        open={create_material_open}
        setOpen={setCreateMaterialOpen}
        setCurrent={handleCurrentMaterial}
        current_type={selected_type} />
      <ShopUpdateMaterial
        open={update_material_open}
        setOpen={setUpdateMaterialOpen}
        current_material={current_material} />
      <ShopCreateColor
        open={create_color_open}
        setOpen={setCreateColorOpen}
        setCurrent={handleCurrentColor}
        current_material={current_material}
        area={area} />
      <ShopUpdateColor
        open={edit_color_open}
        setOpen={setEditColorOpen}
        current_color={current_color}
        current_material={current_material}
        area={area} />
    </Fragment>
  );
}
